<template>
  <header class="header">
    <div class="header-container">
      <!-- banner圖 -->
      <div class="header-banner">
        <picture>
          <!-- 800一下 小圖 -->
          <source
            :srcset="`${context}/public/api/v1/activities/banner?type=WEBSITE_MOBILE_BANNER&activityId=${activityId}`"
            media="(max-width: 800px)"
          />
          <!-- 默認大圖 -->
          <img
            class="banner_img"
            :src="`${context}/public/api/v1/activities/banner?type=WEBSITE_PC_BANNER&activityId=${activityId}`"
            alt="2023科技展"
          />
        </picture>
      </div>
      <!-- 語言切換標籤 -->
      <div class="header-Language">
        <el-button-group>
          <el-button
            v-for="item in langList"
            :key="item.lang"
            size="mini"
            round
            :type="lang === item.lang ? 'primary' : ''"
            @click="onChangeLanguage(item.lang)"
            >{{ item.title }}</el-button
          >
        </el-button-group>
      </div>
    </div>
  </header>
</template>

<script>
import { context } from "@/api/config";
import { mapState } from "vuex";
export default {
  data() {
    return {
      lang: null,
      langList: [],
      context,
    };
  },
  computed: {
    ...mapState({
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
    }),
  },
  watch: {
    activityDetail: {
      handler(v) {
        if (v) {
          const res = [];
          const { languages } = v;
          const types = {
            TC: { lang: "zh", title: "繁體中文" },
            PT: { lang: "pt", title: "Português" },
            EN: { lang: "en", title: "English" },
          };
          if (Array.isArray(languages)) {
            languages.forEach((item) => {
              if (item in types) {
                res.push(types[item]);
              }
            });
          }
          this.langList = res;
        }
      },
      immediate: true,
    },
  },
  created() {
    this.lang = this.$i18n.locale;
  },
  methods: {
    onChangeLanguage(lang) {
      this.$i18n.locale = lang;
      this.lang = lang;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  min-height: 50px;
  .header-banner {
    .banner_img {
      object-fit: contain;
      width: 100%;
      vertical-align: bottom;
    }
  }
  .header-Language {
    position: absolute;
    top: 10%;
    right: 5%;
  }
}
</style>
